/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainEntitiesDocumentsDocumentAccountAcceptFromJSON, FxIdDomainEntitiesDocumentsDocumentAccountAcceptToJSON, } from './FxIdDomainEntitiesDocumentsDocumentAccountAccept';
/**
 * Check if a given object implements the FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsResponse interface.
 */
export function instanceOfFxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsResponse(value) {
    if (!('GameDocumentAccountAccepts' in value) || value['GameDocumentAccountAccepts'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsResponseFromJSON(json) {
    return FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'GameDocumentAccountAccepts': (json['GameDocumentAccountAccepts'].map(FxIdDomainEntitiesDocumentsDocumentAccountAcceptFromJSON)),
    };
}
export function FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsResponseToJSON(json) {
    return FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'GameDocumentAccountAccepts': (value['GameDocumentAccountAccepts'].map(FxIdDomainEntitiesDocumentsDocumentAccountAcceptToJSON)),
    };
}
//# sourceMappingURL=FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsResponse.js.map